import { StarBorderOutlined, StarOutlined } from '@mui/icons-material';

const FeaturedStar = ({ isFeatured = false }) => {
	return isFeatured ? <StarOutlined htmlColor="orange" /> : <StarBorderOutlined />;
};

export default FeaturedStar;
